import React from "react";
import { Flex, Grid, Text } from "@theme-ui/components";
import ShareButton from "./share-button";

const ArticleMeta = ({
  date = "11/08/21",
  author = "AQi Team",
  articleTitle,
}) => (
  <Grid coluns={[2]} className="hide-on-pdf" sx={{ mt: [4, 5], px: [3] }}>
    <Grid columns={1} gap={1} sx={{ gridColumn: ["span 1"], mr: [4, 5, 6] }}>
      <Text sx={{ color: "text", fontWeight: "bold" }} variant="label">
        Date
      </Text>
      <Text variant="paragraph">{date}</Text>
    </Grid>
    <Grid columns={1} gap={0} sx={{ gridColumn: ["span 2"], order: [2] }}>
      <Text sx={{ color: "text", fontWeight: "bold" }} variant="label">
        Author
      </Text>
      <Text variant="paragraph">{author}</Text>
    </Grid>
    <Flex sx={{ mr: 0, ml: "auto", gridColumn: ["span 1"], order: [1] }}>
      <ShareButton articleTitle={articleTitle} />
    </Flex>
  </Grid>
);

export default ArticleMeta;
